"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var generateHiddenFor = function (theme, breakP) {
    var breakPointsMap = {
        Xs: { next: 'S' },
        S: { next: 'M' },
        M: { next: 'L' },
        L: { next: 'Xl' },
        Xl: {}
    };
    var breakPLowerC = breakP.toLowerCase();
    var breakPN = parseInt(theme["SizeBreakpoints" + breakP], 10);
    var breakPNextN = breakPointsMap[breakP].next &&
        parseInt(theme["SizeBreakpoints" + breakPointsMap[breakP].next], 10);
    var breakPMinWidthSt = "(min-width: " + breakPN + "px)";
    var breakPMaxWidthSt = breakPNextN && "(max-width: " + (breakPNextN - 1) + "px)";
    return "\n\n    /* e.g. Xs 0 >=  WIDTH <= 767px */\n    @media " + breakPMinWidthSt + " " + (breakPMaxWidthSt ? "and " + breakPMaxWidthSt : '') + " {\n      .ndsHidden-" + breakPLowerC + " {\n        display: none !important;\n      }\n    }\n\n    /* e.g. Xs WIDTH <= 767px */\n    " + (breakPMaxWidthSt
        ? "@media " + breakPMaxWidthSt + " {\n      .ndsHidden-" + breakPLowerC + "-down {\n        display: none !important;\n      }\n    }"
        : '') + "\n\n    /* e.g. Xs WIDTH >= 0x */\n    @media " + breakPMinWidthSt + " {\n      .ndsHidden-" + breakPLowerC + "-up {\n        display: none !important;\n      }\n    }\n  ";
};
exports.default = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n ", "\n ", "\n ", "\n ", "\n ", "\n\n"], ["\n\n ", "\n ", "\n ", "\n ", "\n ", "\n\n"])), function (props) { return generateHiddenFor(props.theme, 'Xs'); }, function (props) { return generateHiddenFor(props.theme, 'S'); }, function (props) { return generateHiddenFor(props.theme, 'M'); }, function (props) { return generateHiddenFor(props.theme, 'L'); }, function (props) { return generateHiddenFor(props.theme, 'Xl'); });
var templateObject_1;
//# sourceMappingURL=UtilsVisibility.js.map